import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import { ToastController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { FormGroup,FormControl, FormBuilder,Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import{RegisterAswholesellerPage} from 'src/app/pages/register-aswholeseller/register-aswholeseller.page'



@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
name : any;
email1: any;
phone : any;
city : any;
dob: any;
id: any;
address : any;
message : any;
profilee : FormGroup;
registerAsWholesaler:any;
modelData:any;
  userId: any;
  constructor(private router : Router,private formBuilder : FormBuilder,private navController : NavController,private toast : ToastController,private storeService : StoreService, private userService : UserService, private toastService : ToastService,public modalController: ModalController) { }

  ngOnInit() {
    console.log("heelo hi")
    let a = {
      uid: this.userService.uid
    }
      this.userService.getUserDetails(a).subscribe((res: any)=>{
        console.log("getUserDetails ", res);
        this.city=res.city;
        // this.dob= new Date(res.dob).toJSON().slice(0,10);
        this.email1=res.email1,
        this.name=res.name,
        this.phone=res.phone
        this.id = res._id
        this.address=res.address
        
        console.log(this.dob)

        this.profilee = this.formBuilder.group({
          name : new FormControl(this.name,[Validators.required]),
          email1 : new FormControl(this.email1,[Validators.required,Validators.email]),
          // dob : new FormControl(this.dob,Validators.required),
          city : new FormControl(this.city,Validators.required),
          phone : new FormControl(this.phone,Validators.required),
        })

      })
  }




  getDetails(){

  }


  update(){
    if(this.profilee.controls.name.errors?.required ){
      this.toastService.presentToast("Please enter your name")
    }
    else if(this.profilee.controls.email1.errors?.email){
      this.toastService.presentToast("Please enter valid email address")
    }
    // else if(this.profilee.controls.dob.errors?.required){
    //   this.toastService.presentToast("Please enter your DOB")
    // }
    else{
    let dataa={
      address : this.address,
      // dob : this.profilee.value.dob,
      city : this.profilee.value.city,
      email1 : this.profilee.value.email1,
      name : this.profilee.value.name,
      id : this.id
    }
  this.userService.updateDetails(dataa).subscribe((res :any)=>{
    console.log(res)
    this.message=res;
    this.toastService.presentToast(this.message.message);
    this.userService.profileUpdated.next(true);
    this.getDetails();
    this.router.navigate(['/account-page'])
  })}
  
  }

  goBack() {
    this.navController.pop();
  }

  // async presentToast() {
  //   const toast = await this.toast.create({
  //     message: 'Your settings have been saved.',
  //     duration: 2000
  //   });
  //   toast.present();
  // }

 

  async openModal(item: any) {
    const modal = await this.modalController.create({
      component: RegisterAswholesellerPage,
      // componentProps: {
      //   'model_title': item
      // }
    });
    modal.onDidDismiss().then((modelData) => {
      // if (modelData !== null) {
      //   this.modelData = modelData.data;
       
      //   console.log('Modal Data : ' + modelData);
      // }
    });
    return await modal.present();
  }

}

